enum CompanyUserImportSettingsType {
  SftpFileTransfer = 1,
  API = 2,
}
export default CompanyUserImportSettingsType;
